import { RadioProps, Flex, Image, Text, Radio } from "@chakra-ui/react";
import { gray300, gray700 } from "core/resources/theme/colors";

interface RadioFiltroProps extends Omit<RadioProps, "color"> {
  imageIcon?: string | null;
  color?: string | null;
  text: string;
  disabled?: boolean;
  onClick: () => any;
}
function RadioFiltro({
  imageIcon,
  color,
  text,
  disabled,
  onClick,
  ...rest
}: RadioFiltroProps) {
  return (
    <Radio
      onChange={() => (!disabled ? onClick() : null)}
      size="md"
      borderColor={disabled ? gray300 : gray700}
      cursor={disabled ? "not-allowed" : "pointer"}
      {...rest}
    >
      <Flex alignItems="center" justifyContent="center">
        {imageIcon ? (
          <Image src={imageIcon || undefined} h="16px" mr={2} />
        ) : color ? (
          <Flex
            h="15px"
            w="15px"
            bg={color}
            mr={2}
            borderRadius="3px"
            border={color === "#FFFFFF" ? "1px solid" : "none"}
            borderColor={color === "#FFFFFF" ? "gray.400" : "none"}
          />
        ) : null}
        <Text
          color={disabled ? gray300 : gray700}
          fontSize="16px"
          fontWeight={rest.isChecked ? "bold" : "400"}
        >
          {text}
        </Text>
      </Flex>
    </Radio>
  );
}

export default RadioFiltro;
